import { render, staticRenderFns } from "./header.vue?vue&type=template&id=98f70f90&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f70f90",
  null
  
)

export default component.exports